import {Action} from "@ngrx/store";
import {IWorkspaceIdEntities} from "../reducers/workspace.reducer";
import {WorkspaceClient} from "../../user-managment/workspace-client";
import {WorkspaceInvitation} from "../../user-managment/workspace-invitation";
import {Workspace} from "../../user-managment/workspace";

export const SET_WORKSPACE_ID_ENTITIES: string = '[workspace] Set Workspace Id Entities';

export const LOAD_WORKSPACE_CLIENTS: string = '[workspace] Load Workspace Clients';

export const LOAD_WORKSPACE_INVITATIONS: string = '[workspace] Load Workspace Invitations';

export const LOAD_WORKSPACE_ALL_CLIENTS: string = '[workspace] Load Workspace Clients ALL Clients';

export const LOAD_WORKSPACE_ALL_CLIENTS_SUCCESS: string = '[workspace] Load Workspace Clients ALL Clients Success';

export const LOAD_WORKSPACE_ALL_CLIENTS_FAIL: string = '[workspace] Load Workspace Clients ALL Clients Fail';

export const LOAD_BILLING_INFO: string = '[billing info] Load Billing Info';

export const LOAD_BILLING_INFO_SUCCESS: string = '[billing info] Load Billing InfoSuccess';

export const LOAD_BILLING_INFO_FAIL: string = '[billing info] Load Billing Info Fail';

export const LOAD_WORKSPACES: string = '[workspace] Load Workspaces';

export const UPDATE_WORKSPACE: string = '[workspace] Update Workspace';

export const RESET_WORKSPACE_STATE: string = '[workspace] Reset Workspace State';

export class SetWorkspaceIdEntities implements Action {

  readonly type: string = SET_WORKSPACE_ID_ENTITIES;
  constructor(public payload?: IWorkspaceIdEntities) {}

}

export class LoadWorkspaceClients implements Action {

  readonly type: string = LOAD_WORKSPACE_CLIENTS;
  constructor(public payload: WorkspaceClient[]) {}

}

export class LoadWorkspaceInvitations implements Action {

  readonly type: string = LOAD_WORKSPACE_INVITATIONS;
  constructor(public payload: WorkspaceInvitation[]) {}

}

export class LoadWorkspaceAllClients implements Action {

  readonly type: string = LOAD_WORKSPACE_ALL_CLIENTS;
}

export class LoadWorkspaceAllClientsSuccess implements Action {

  readonly type: string = LOAD_WORKSPACE_ALL_CLIENTS_SUCCESS;
  constructor(public payload: {clients: WorkspaceClient[], invitations: WorkspaceInvitation[]}) {}

}

export class LoadWorkspaceAllClientsFail implements Action {

  readonly type: string = LOAD_WORKSPACE_ALL_CLIENTS_FAIL;
  constructor(public payload: string) {}

}

export class LoadBillingInfo implements Action {

  readonly type: string = LOAD_BILLING_INFO;
}

export class LoadBillingInfoSuccess implements Action {

  readonly type: string = LOAD_BILLING_INFO_SUCCESS;
  constructor(public payload: any) {}

}

export class LoadBillingInfoFail implements Action {

  readonly type: string = LOAD_BILLING_INFO_FAIL;
  constructor(public payload: string) {}

}

export class LoadWorkspaces implements Action {

  readonly type: string = LOAD_WORKSPACES;
  constructor(public payload: Workspace[]) {}

}

export class UpdateWorkspace implements Action {

  readonly type: string = UPDATE_WORKSPACE;
  constructor(public payload: Workspace) {}

}

export class ResetWorkspaceState implements Action {

  readonly type: string = RESET_WORKSPACE_STATE;

}

export type WorkspaceAction = SetWorkspaceIdEntities | LoadWorkspaceClients | LoadWorkspaceInvitations | LoadWorkspaceAllClients | LoadWorkspaceAllClientsSuccess | LoadWorkspaceAllClientsFail | LoadBillingInfo | LoadBillingInfoSuccess | LoadBillingInfoFail | LoadWorkspaces | UpdateWorkspace;
